import { Routes, Route } from 'react-router'
import EmailConfirmation from './pages/EmailConfirmation.jsx'
import { Profile } from './pages/Profile.jsx'
import Entreprise from './pages/Entreprise.jsx'
import { Informations } from './pages/Informations.jsx'
import { ChangePassword } from './pages/ChangePassword.jsx'
import { ChestDocument } from './pages/ChestDocument.jsx'
import { DocumentHistory } from './pages/DocumentHistory.jsx'
import { ViewDocument } from './pages/ViewDocument.jsx'
import { DeleteDocument } from './pages/DeleteDocument.jsx'
import Dashboard from './pages/Dashboard.jsx'
import Registration from './pages/Registration.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import SuccessResetPassword from './pages/SuccessResetPassword.jsx'
import { MainLayout } from './layouts/MainLyouts.jsx'
import { ImportDocument } from './pages/ImportDocument.jsx'
import Login from './pages/Login.jsx'
import { ResetPassword } from './pages/ResetPassword.jsx'
import ForgotPassword from './pages/ForgotPassword.jsx'
import Consultation from './pages/Consultation.jsx'
import { SubscriptionList } from './pages/SubscriptionList.jsx'
import { EditDocument } from './pages/EditDocument.jsx'
import DeleteDocTreated from './pages/DeleteDocTreated.jsx'
import CalendarFilter from './pages/CalendarFilter.jsx'
import { PaymentMethodPage } from './pages/PaymentMethodPage.jsx'
import { PaymentSucceeded } from './pages/PaymentSucceeded.jsx'
import PayementList from './pages/PaymentList.jsx'
import { UnauthorizedPage } from './pages/UnauthorizedPage.jsx'
import Layout from './components/Layout.jsx'
import { AdminHome } from './pages/admin/AdminHome.jsx'
import Document from './pages/admin/documentFolder/Document.jsx'
import AddDocument from './pages/admin/documentFolder/AddDocument.jsx'
import CompanyList from './pages/admin/society/CompanyList.jsx'
import UserList from './pages/admin/users/UserList.jsx'
import PaymentFailed from './pages/PaymentFailed.jsx'
import CallRememberList from './pages/admin/callRemember/CallRememberList.jsx'
import LoginAdmin from './pages/LoginAdmin.jsx'
import SucceededChangePassword from './pages/SucceededChangePassword.jsx'
import OAuthRedirect from './components/OAuthRedirect'; 

export default function Router () {
  return (
    <MainLayout>
      <Routes>
        {/* <Route path="/" element={<Navigate to="/login" replace />} /> */}
        <Route path='/login' element={<Login />} index />
        <Route path='/contab-admin-login' element={<LoginAdmin />} index />
        <Route path='/sign-up' element={<Registration />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password/:token' element={<ResetPassword />} />
        <Route path="/auth/success" element={<OAuthRedirect />} />
        <Route
          path='/succeded-change-password'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <SucceededChangePassword />
            </ProtectedRoute>
          }
        />
        <Route
          path='/reset-password-message'
          element={<SuccessResetPassword />}
        />
        <Route path='/unauthorized' element={<UnauthorizedPage />} />

        <Route
          path='/import-document'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <ImportDocument />
            </ProtectedRoute>
          }
        />
        <Route
          path='/email-confirmation'
          element={
            // <ProtectedRoute>
            <EmailConfirmation />
            // </ProtectedRoute>
          }
        />
        <Route
          path='/'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path='/customer'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path='/entreprise/add'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <Entreprise />
            </ProtectedRoute>
          }
        />
        <Route
          path='/history'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <DocumentHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path='/informations'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <Informations />
            </ProtectedRoute>
          }
        />
        <Route
          path='/change-password'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <ChangePassword />
            </ProtectedRoute>
          }
        />
        <Route
          path='/chest-of-documents'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <ChestDocument />
            </ProtectedRoute>
          }
        />
        <Route
          path='/view-document'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <ViewDocument />
            </ProtectedRoute>
          }
        />
        <Route
          path='/delete-confirmation'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <DeleteDocument />
            </ProtectedRoute>
          }
        />
        <Route
          path='/consultation'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <Consultation />
            </ProtectedRoute>
          }
        />

        <Route
          path='/edit-document'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <EditDocument />
            </ProtectedRoute>
          }
        />
        <Route
          path='/subscription-list'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <SubscriptionList />
            </ProtectedRoute>
          }
        />
        <Route
          path='/delete-document-treated'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <DeleteDocTreated />
            </ProtectedRoute>
          }
        />
        <Route
          path='/calendar-filter'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <CalendarFilter />
            </ProtectedRoute>
          }
        />
        <Route
          path='/payment-method'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <PaymentMethodPage />
            </ProtectedRoute>
          }
        />
        <Route
          path='/payment-succeeded'
          element={
            // <ProtectedRoute allowedRoles={['ROLE_USER']}>
            <PaymentSucceeded />
            // </ProtectedRoute>
          }
        />
        <Route path='/payment-failed' element={<PaymentFailed />} />
        <Route
          path='/payment-list'
          element={
            <ProtectedRoute allowedRoles={['ROLE_USER']}>
              <PayementList />
            </ProtectedRoute>
          }
        />

        <Route
          path='/contab-admin'
          element={
            <ProtectedRoute allowedRoles={['ROLE_ADMIN']}>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminHome />} />
          <Route path='document' element={<Document />} />
          <Route path='document/add' element={<AddDocument />} />
          <Route path='user' element={<UserList />} />
          <Route path='society' element={<CompanyList />} />
          <Route path='call-remember' element={<CallRememberList />} />
        </Route>
      </Routes>
    </MainLayout>
  )
}
